<template>
  <div class="contractongoing">
    <div class="row m-0 h-100 justify-content-center align-items-center" v-if="isLoadingOnGoing">
      <b-spinner  variant="secondary"/>
    </div>
    <div class="row m-0 contractongoing__contain" v-else>
      <div class="contractongoing__title" :class="{ 'color_purple' : custDetail.service_head === 'AIR'}">Congratulation! your contract is now on going!</div>
      <p>You can now start your shipment by clicking “Add Shipment” button and monitor it by clicking “Manage Shipment” button. </p>
      <div class="row m-0 my-3 w-100">
        <div class="col-md-8 p-0">
          <div class="row m-0">
            <p class="col-md-4 p-0">Remaining Days</p>
            <p class="col-md">: {{custDetail.remaining_days > 1 ? `${custDetail.remaining_days} Day` : `${custDetail.remaining_days} Days` }}</p>
          </div>
          <div class="row m-0">
            <p class="col-md-4 p-0">Estimate Contract Value</p>
            <p class="col-md">: IDR {{custDetail.estimate_contract_value | Currency}}</p>
          </div>
          <div class="row m-0">
            <p class="col-md-4 p-0">Remaining Contract Value</p>
            <p class="col-md">: IDR {{custDetail.remaining_contract_value | Currency}}</p>
          </div>
        </div>
        <div class="col-md-4 p-0 d-flex flex-column align-items-center justify-content-center">
          <button class="mb-2" :class="custDetail && custDetail.service_head === 'AIR' ? 'button__purplesmall' : 'button__bluesmall'" style="min-width: 145px"
          :disabled="!custDetail.file_id || !custDetail.file_category || getStatus(custDetail)"
          @click="showAgreement()">
            <b-spinner small v-if="isLoadingAgreement"></b-spinner>
            <span v-else>Show Agreement</span>
          </button>
          <button :class="custDetail && custDetail.service_head === 'AIR' ? 'button__purplesmall' : 'button__bluesmall'" style="min-width: 145px" @click="addShipment()">Add Shipment</button>
        </div>
      </div>
      <div class="mb-3" v-if="calculateOngoing > 0 || calculateComplete > 0"> {{calculateOngoing}} on going shipment, {{calculateComplete}} completed shipment</div>
      <div class="row m-0 mb-2 ongoing_list" v-for="(item, i) in OnGoing" :key="i">
        <div class="col-md-8 p-0 col1">
          <div class="createdAt" :class="{ 'global__bc_purple' : custDetail.service_head === 'AIR'}">
            Created on {{getDateDefauld(item.created_at)}}</div>
          <div class="detail">
            <div class="row m-0 w-100">
              <div class="col-md-2 p-0">Order Number</div>
              <div class="px-1">:</div>
              <div class="col-md p-0">{{item.order_number}}</div>
            </div>
            <div class="row m-0 w-100">
              <div class="col-md-2 p-0">Shipment Date</div>
              <div class="px-1">:</div>
              <div class="col-md p-0">{{getDateDefauld(item.shipment_date)}}</div>
            </div>
            <div class="row m-0 w-100">
              <div class="col-md-2 p-0">{{item.freight_type !== 'AIRCARGO' && item.freight_type !== 'AIRCOURIER' && item.freight_type !== 'SEALCL' ? 'Total Container' : 'Total Quantity'}}</div>
              <div class="px-1">:</div>
              <div class="col-md p-0">{{getQty(item.freight_sum, item.freight_type, item.satuan)}}</div>
            </div>
            <div class="row m-0 w-100">
              <div class="col-md-2 p-0">Current Status</div>
              <div class="px-1">:</div>
              <div class="col-md p-0">{{item.order_stat.split('_').join(' ').replace(/OTIF/g, '') |
                capitalize}}</div>
            </div>
            <div class="row m-0 w-100">
              <div class="col-md-2 p-0">Notes</div>
              <div class="px-1">:</div>
              <div class="col-md p-0">{{item.shipper_notes}}</div>
            </div>
          </div>
        </div>
        <div class="col-md p-0 col2">
          <router-link :to="{
            name: 'ManagementShipmentDetail',
            params: { id_shipment: item.id,
              order_number: item.order_number.split('/').join('-') }
            }"
            tag="button"
            :class="custDetail && custDetail.service_head === 'AIR' ? 'button__purplesmall' : 'button__bluesmall'"
            class="mb-2">
            Go to Manage Shipment
          </router-link>
          <p :class="{ 'color_purple' : custDetail.service_head === 'AIR'}" @click="pricedetail(item.id, item.order_number, item.status_shipment)">Show Price Detail</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinDateTime from '@/mixin/getters/date-time'
import mixinGetStatus from '@/mixin/getters/status-bid'

export default {
  name: 'contractongoing',
  props: {
    custDetail: Object
  },
  mixins: [mixinDateTime, mixinGetStatus],
  computed: {
    ...mapGetters({
      OnGoing: 'contract/OnGoing',
      isLoadingOnGoing: 'contract/isLoadingOnGoing',
      isErrorOnGoing: 'contract/isErrorOnGoing',

      errorDownloadBA: 'contract/errorDownloadBA',
      isLoadingDownloadBA: 'contract/isLoadingDownloadBA',

      isLoadingAgreement: 'contract/isLoadingAgreement',
      isErrDownloadAgreement: 'contract/isErrDownloadAgreement'
    }),
    calculateOngoing () {
      if (this.OnGoing) {
        const list = this.OnGoing.filter(item => {
          return (item.order_stat !== 'COMPLETED' && item.order_stat !== 'COMPLETED_OTIF' && item.order_stat !== 'REJECTED' && item.order_stat !== 'CANCELLED')
        })
        return list.length
      }
    },
    calculateComplete () {
      if (this.OnGoing) {
        const list = this.OnGoing.filter(item => {
          return (item.order_stat === 'COMPLETED' || item.order_stat === 'COMPLETED_OTIF' || item.order_stat === 'REJECTED' || item.order_stat === 'CANCELLED')
        })
        return list.length
      }
    },
    filteredOngoing () {
      return this.OnGoing.slice().reverse()
    }
  },
  mounted () {
    this.fetchShipmentOngoing()
  },
  methods: {
    getQty (freight, type, satuan) {
      let qty = ''
      const newQty = JSON.parse(freight)
      if (type === 'AIRCARGO' || type === 'AIRCOURIER' || type === 'SEALCL') {
        qty = `${Math.floor(newQty.qty)} ${satuan}`
      } else {
        qty = `${Math.floor(newQty.qty)} Container`
      }
      return qty
    },
    getWeight (weight) {
      const mySubString = JSON.parse(weight)
      return mySubString.weight
    },
    getVolume (volume) {
      const mySubStringVolume = JSON.parse(volume)
      return mySubStringVolume.volume
    },
    getDimension (dimension) {
      if (dimension) {
        const newdimension = JSON.parse(dimension)
        return (`${newdimension.length ? newdimension.length : '0'}x${newdimension.width ? newdimension.width : '0'}x${newdimension.height ? newdimension.height : '0'} cm`)
      }
    },
    pricedetail (shipmentId, numberOrder, statusShipment) {
      const orderNumber = numberOrder.split('/').join('-')
      this.$store.dispatch('shipment/FETCH_SHIPMENT_PRICE', {shipmentId, orderNumber})
      const remarks = ''
      this.$eventHub.$emit('dialog-pricedetails-shipment', {typeShipment: statusShipment, remarks})
    },
    async fetchShipmentOngoing () {
      const id = this.$route.params.id_contract
      await this.$store.dispatch('contract/GET_SHIPMENT_ONGOING', id)
      await this.$store.dispatch('contract/GET_CONTRACT_DETAIL', id)
      await this.$store.dispatch('contract/FETCH_BID_CONTRACT', id)
    },
    addShipment () {
      const remainingDays = parseInt(this.custDetail.remaining_days)
      const estimateContractValue = parseInt(this.custDetail.estimate_contract_value)
      if (remainingDays > 0 && estimateContractValue !== 0) {
        this.$eventHub.$emit('dialog-add-shipment', this.custDetail.shipment_type, this.custDetail.duration_start, this.custDetail.duration_end)
      } else {
        this.$eventHub.$emit('dialog-cant-addshipment', remainingDays, estimateContractValue)
      }
    },
    async downloadBA () {
      const id = this.$route.params.id_contract
      const bidId = this.bidId
      const fileName = `Business-Agreement-${this.$route.params.contractNumber}.pdf`
      await this.$store.dispatch('contract/DOWNLOAD_BUSINESS_AGREEMENT', {id, fileName, bidId})
    },
    async showAgreement () {
      if (this.custDetail && !this.isLoadingAgreement) {
        const ctcDet = this.custDetail
        // store to variable
        const shipmentId = ctcDet.id
        const type = 'CONTRACT'
        const fileCategory = ctcDet.file_category
        const fileName = `${ctcDet.file_category}${ctcDet.file_ext}`
        const contractNumber = this.$route.params.contractNumber.split('/').join('-')
        const fileId = ctcDet.file_id
        await this.$store.dispatch('contract/SHOW_AGREEMENT_CTC', {shipmentId, contractNumber, type, fileName, fileCategory, fileId})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/Ongoing.vue